import axios from 'axios'

export class ImageApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      baseURL: 'https://api.photos-presse.com/image-signed-url',
      timeout: 10000
    })
  }

  public async getSignedUrl(photo_id: number, quality: string): Promise<string> {
    return this.m_instance.get(`/signed_url/${photo_id}/${quality}`)
  }
}
